import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import '../Footer/scss/Footer2.scss';
import logo from '../../assets/logoSecond.png'
import SpinnerPage from '../hero/SpinnerPage';
import axios from '../../Utilities/axios';
import * as Yup from "yup";
import { useFormik } from "formik";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Footer = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [subscribed, setSubscribed] = useState(false);

  const today = new Date();
  const currentYear = today.getFullYear();

  const notifySuccess = () => {
    toast.success("Thank you for subscribing!", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "colored",
    });
  };

  const notifyError = (msg) => {
    toast.error(msg || "Subscription failed. Please try again.", {
      position: "top-right",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "colored",
    });
  };

  const formik = useFormik({
    initialValues: {
      emailAddress: "",
    },
    validationSchema: Yup.object({
      emailAddress: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      try {
        const res = await axios.post("/registrations/createSubscribers", values);
        if (res.data.message === "subscription created successfully") {
          notifySuccess();
          setSubscribed(true);
          resetForm();
        } else {
          notifyError(res.data.message);
        }
      } catch (err) {
        notifyError();
      }
    },
  });

  return (
    <div>
      {isLoading && <SpinnerPage />}

      <footer className="footer-area section_gap">
        <div className="container">
          <div className="footer-main">
            {/* Logo & Tagline */}
            <div className="footer-brand">
              <Link to="/" className="footer-logo">
                <img src={logo} alt="Residency Hotels" width="160" />
              </Link>
              <p className="footer-tagline">
                World-class hospitality across Nigeria's finest locations.
              </p>
              <div className="footer-social">
                <a href="https://www.facebook.com/windloungelagos" target="_blank" rel="noreferrer" aria-label="Facebook">
                  <i className="fa fa-facebook" />
                </a>
                <a href="https://twitter.com/residency_hote" target="_blank" rel="noreferrer" aria-label="Twitter">
                  <i className="fa fa-twitter" />
                </a>
                <a href="https://www.instagram.com/residency_hotels/" target="_blank" rel="noreferrer" aria-label="Instagram">
                  <i className="fa fa-instagram" />
                </a>
              </div>
            </div>

            {/* Quick Links */}
            <div className="footer-links">
              <h6 className="footer_title">Quick Links</h6>
              <ul className="list_style">
                <li><Link to="/About-Residency-Hotels">About Us</Link></li>
                <li><Link to="/Special-Promo">Special Promo</Link></li>
                <li><Link to="/EventHall">Event Center</Link></li>
              </ul>
            </div>

            {/* Contact Info */}
            <div className="footer-contact">
              <h6 className="footer_title">Contact Us</h6>
              <ul className="list_style">
                <li>
                  <i className="fa fa-map-marker" />
                  Plot 740, Nasir El Rufai Crescent, Guzape Hills, Abuja
                </li>
                <li>
                  <i className="fa fa-phone" />
                  <a href="tel:08083664874">080 8366 4874</a>
                </li>
                <li>
                  <i className="fa fa-envelope" />
                  <a href="mailto:booking@myresidencyhotel.com">booking@myresidencyhotel.com</a>
                </li>
              </ul>
            </div>

            {/* Newsletter */}
            <div className="footer-newsletter">
              <h6 className="footer_title">Stay Updated</h6>
              <p className="newsletter-text">Subscribe for exclusive offers and updates.</p>
              {subscribed ? (
                <div className="newsletter-success">
                  <i className="fa fa-check-circle" />
                  <span>Thank you for subscribing!</span>
                </div>
              ) : (
                <form className="newsletter-form" onSubmit={formik.handleSubmit}>
                  <input
                    type="email"
                    placeholder="Your email address"
                    value={formik.values.emailAddress.trimStart()}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    name="emailAddress"
                  />
                  <button type="submit">
                    <i className="fa fa-paper-plane" />
                  </button>
                  {formik.touched.emailAddress && formik.errors.emailAddress ? (
                    <p className="newsletter-error">{formik.errors.emailAddress}</p>
                  ) : null}
                </form>
              )}
            </div>
          </div>

          <div className="border_line" />

          <div className="footer-bottom">
            <p className="footer-text">
              &copy; {currentYear} Residency Hotels Limited. All rights reserved.
            </p>
            <p className="footer-text">
              Powered by <a href="http://ontractech.com" target="_blank" rel="noreferrer">Ontrac Technology Limited</a>
            </p>
          </div>
        </div>
      </footer>
      <ToastContainer />
    </div>
  );
};

export default Footer;
